/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { type Table } from '@tanstack/react-table';
import xlsx, { type IJsonSheet } from 'json-as-xlsx';
import { type DataTableColumnDef } from '../models/DataTableColumnDef';
import { getRowValue } from '@/app/modules/export/getRowValue';
import { type ExportConfig } from '../modules/export/types';
import { getRandomString } from './getRandomString';

/**
 * New export function using ExportConfig
 */
export function exportToExcelFromConfig(config: ExportConfig) {
  const { columns, rows, filename } = config;

  const content = rows.map((row) => {
    const result: Record<string, any> = {};
    for (const col of columns) {
      const value = getRowValue(row, col.key);
      if (col.format) {
        result[col.key] = col.format(row) ?? '';
      } else {
        result[col.key] = value ?? '';
      }
    }
    return result;
  });

  const tableColumns = columns.map((col) => ({
    label: col.header,
    value: col.key,
  }));

  const jsonSheets: IJsonSheet[] = [
    {
      sheet: 'Dados',
      columns: tableColumns,
      content,
    },
  ];

  xlsx(jsonSheets, {
    fileName: filename || getRandomString(10),
  });
}

/**
 * @deprecated Use exportToExcelFromConfig with ExportConfig instead.
 */
export function exportToExcel(
  columns: DataTableColumnDef<object>[],
  table?: Table<object>,
  sheetName?: string,
  fileName?: string,
) {
  if (!table) return;

  const content = table.getRowModel().rows.map((row) => {
    const result: Record<string, any> = { ...row.original };

    columns
      .filter((column) => column && column.isPrintable !== false)
      .forEach((column) => {
        if (!column.accessorKey) return;
        if (column.print) {
          result[column.accessorKey] = column.print(row) as string | number | boolean;
          return;
        }
        result[column.accessorKey] = row.getValue(column.accessorKey);
      });

    return result;
  });

  const tableColumns: { label: string; value: string }[] = columns
    .filter((componentColumns) => componentColumns && componentColumns.isPrintable !== false)
    .map((column) => ({
      label: String(column.header) || '',
      value: column.accessorKey || '',
    }));

  const jsonSheets: IJsonSheet[] = [
    {
      sheet: sheetName || getRandomString(10),
      columns: tableColumns,
      content: content,
    },
  ];

  const settings = {
    fileName: fileName || getRandomString(10),
  };

  xlsx(jsonSheets, settings);
}
